import { render } from "./ResetPage.vue?vue&type=template&id=31bb5646&scoped=true"
import script from "./ResetPage.vue?vue&type=script&lang=js"
export * from "./ResetPage.vue?vue&type=script&lang=js"

import "./ResetPage.vue?vue&type=style&index=0&id=31bb5646&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src802653185/src/macra-logistics-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-31bb5646"]])

export default __exports__